export const faqMutations = {
  setFaqFormStatus(state, payload) {
    state.faqFormStatus = payload;
  },
  setFaqIsEdit(state, payload) {
    state.faqIsEdit = payload
  },
  setFaqSelectedForEdit(state, payload) {
    state.faqSelectedForEdit = payload
  },
  setFaqBackFromEditPage(state, payload){
    state.faqBackFromEditPage = payload
  },
  setFaqTableItems(state, payload){
    state.faqTableItems = payload
  },
  setFaqPageCount(state, payload){
    state.faqPageCount = payload
  },
};